import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"

const NoAccountsRow = () => (
  <Grid.Row
    columns="equal"
    className="ConnectedAccount__Row"
    style={{ color: "#ababab" }}
  >
    <Grid.Column textAlign="center">No Accounts</Grid.Column>
  </Grid.Row>
)

export default NoAccountsRow
